import { formatPhone, requestResourceByName, resetFormByName, useScopedSelector } from 'ia-react-core';
import React, { FC, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useMarkPageLoaded } from 'omni-package-react-core';
import { MfaValidationPageState } from '../../../../interfaces/MfaValidationPageState';
import MfaCodeValidation from '../../components/MfaCodeValidation';

export interface MfaPhoneCodeStepProps {
}

const MfaPhoneCodeStep: FC<MfaPhoneCodeStepProps> = () => {
  const { i18n } = useTranslation('MfaValidationPage');
  const dispatch = useDispatch();
  const isInitialRender = useRef(true);

  const { method } = useScopedSelector(({ values }: MfaValidationPageState) => values.mfa.phone);

  useMarkPageLoaded();

  useEffect(() => {
    if (!isInitialRender.current) {
      dispatch(resetFormByName('forms.phoneCode'));
      dispatch(requestResourceByName('resources.sendCode'));
    }
    isInitialRender.current = false;
  }, [dispatch, method]);

  return (
    <MfaCodeValidation
      method={method}
      informationType="phone"
      formatInfo={(info: string) => formatPhone(parseInt(info, 10), { locale: i18n.language })}
    />
  );
};

export default MfaPhoneCodeStep;
